import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReporteService } from '../../services/reportes/reporte.service';
import { WeeklyReport } from '../../models/report-client';
import { AppComponent } from '../../app.component';

@Component({
  selector: 'app-report-weekly',
  templateUrl: './report-weekly.component.html',
  styleUrls: ['./report-weekly.component.scss']
})
export class ReportWeeklyComponent implements OnInit {

  reports: WeeklyReport[] = [];
  loading = true;

  constructor(
    private reportService: ReporteService,
    private router: Router,
    private appComponent: AppComponent
  ) {}

  ngOnInit() {
    this.loadReports();

    this.reportService.markWeeklyReportsAsRead().then(() => {
      this.appComponent.clearWeeklyNotification();
    });
  }

 async loadReports() {
  this.reportService.getAllReportsWeekly().subscribe({
    next: (res: any) => {
      // res.data ya es un array de WeeklyReport
      this.reports = res.data.map((r: any) => ({
        _id: r._id,
        date: r.date,
        totalClientes: r.totalClientes,
        data: r.data
      }));
      this.loading = false;
    },
    error: (err) => {
      console.error('Error obteniendo reportes semanales:', err);
      this.loading = false;
    }
  });
}

  async markReportsAsRead() {
    try {
      await this.reportService.markWeeklyReportsAsRead();
      console.log('📘 Reportes marcados como leídos');
    } catch (error) {
      console.error('Error marcando como leídos:', error);
    }
  }

  openReport(reportId: string) {
    this.router.navigate(['/reports/weekly', reportId]);
  }
}
